import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-danger */
/* eslint-disable react/destructuring-assignment */
import { useMemo } from 'react';
import { Box, Skeleton } from '@mui/material';
import Carousel from 'react-multi-carousel';
import { observer } from 'mobx-react-lite';
import PortalItemCard from './PortalItemCard';
const CarouselSkeleton = () => (_jsx(Box, { sx: {
        display: 'flex',
        gap: 2,
        overflow: 'hidden',
        '& > *': {
            flexShrink: 0,
        },
    }, children: [...Array(4).keys()].map((i) => (_jsxs(Box, { sx: {
            minWidth: { xs: '100%', sm: '280px' },
            maxWidth: { xs: '100%', sm: '280px' },
            margin: '4px 8px',
        }, children: [_jsx(Skeleton, { variant: "rectangular", width: "100%", height: 200, sx: { mb: 1 } }), _jsx(Skeleton, { variant: "text", width: "80%", height: 24, sx: { mb: 0.5 } }), _jsx(Skeleton, { variant: "text", width: "60%", height: 20, sx: { mb: 1 } }), _jsx(Skeleton, { variant: "text", width: "100%", height: 16 }), _jsx(Skeleton, { variant: "text", width: "90%", height: 16 })] }, i))) }));
export const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 1536 },
        items: 4,
    },
    largeDesktop: {
        breakpoint: { max: 1536, min: 1200 },
        items: 4,
    },
    desktop: {
        breakpoint: { max: 1200, min: 900 },
        items: 4,
    },
    tablet: {
        breakpoint: { max: 900, min: 600 },
        items: 3,
    },
    mobile: {
        breakpoint: { max: 600, min: 0 },
        items: 1,
    },
};
const ItemCarousel = ({ items = [], showPrice = true, cardShowTitle = true, cardShowImage = true, cardShowInfoBar = true, cardShowInstructor = true, cardShowDescription = true, cardMaxLinesDescription = 4, maxItemCount, padding, backgroundColor, limitToPageWidth, onProductClick, onPortalRelativeNavigate, openInNewTab = false, cardShowActionButton = true, }) => {
    const cardConfig = useMemo(() => ({
        courseCardShowPrice: showPrice,
        courseCardShowTitle: cardShowTitle,
        courseCardShowImage: cardShowImage,
        courseCardShowInstructor: cardShowInstructor || false,
        courseCardMaxLinesDescription: cardMaxLinesDescription,
        courseCardShowDesc: cardShowDescription,
        courseCardShowInfoBar: cardShowInfoBar,
        courseCardShowActionButton: cardShowActionButton,
    }), [
        showPrice,
        cardShowDescription,
        cardShowTitle,
        cardShowImage,
        cardShowInfoBar,
        cardShowInstructor,
        cardMaxLinesDescription,
        cardShowActionButton,
    ]);
    const isServer = typeof window === 'undefined';
    return (_jsx(Box, { sx: {
            backgroundColor: { backgroundColor },
            p: (`${padding}px`),
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: items.length > 0 && (isServer ? (_jsx(CarouselSkeleton, {})) : (_jsx(Carousel, { responsive: responsive, ssr: false, children: items.filter(Boolean).slice(0, maxItemCount).map((item) => (_jsx(Box, { sx: {
                    margin: '4px 8px',
                }, children: _jsx(PortalItemCard, { config: cardConfig, title: item.title, image: item.image || item.screenshot, description: item.description, url: item.url, width: "100%", openInNewTab: openInNewTab, onProductClick: onProductClick, onPortalRelativeNavigate: onPortalRelativeNavigate, product: item }, item.id) }, item.id))) }))) }));
};
ItemCarousel.defaultProps = {
    items: [],
    showPrice: true,
    cardShowTitle: true,
    cardShowImage: true,
    cardShowInfoBar: true,
    cardShowInstructor: true,
    cardShowDescription: true,
    cardMaxLinesDescription: 4,
    maxItemCount: 20,
    padding: 0,
    cardShowActionButton: true,
    onProductClick: undefined,
    onPortalRelativeNavigate: undefined,
    openInNewTab: false,
};
export default observer(ItemCarousel);
//# sourceMappingURL=ItemCarousel.js.map